/* unplugin-vue-components disabled */import script from "./item.vue?vue&type=script&lang=ts&setup=true"
export * from "./item.vue?vue&type=script&lang=ts&setup=true"

import "./item.vue?vue&type=style&index=0&id=4775e2c3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4775e2c3"]])

export default __exports__